import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setSearch, setHighlightedIds, clearHighlightedIds, setHighlightedShopifyIds, clearHighlightedShopifyIds } from "../../app/orderApi/filterSlice";
import { MinusSvg } from "../../svgFiles/MinusSvg";
import Orderstatus from "./Orderstatus";
import Glassonly from "./Glassonly";
import Button from "../../components/shared/buttons/button";
import { AddSvg } from "../../svgFiles/AddSvg";
import InputGroup from 'react-bootstrap/InputGroup';
import {
  useUpdateOrderStatusMutation,
  useRedoOrderMutation,
  useSoftDeleteOrdersMutation,
} from "../../app/orderApi/OrderApi";
import { factoryOptions, statusesOptions } from "../enums/orderEnums";
import { showToast } from "../../helpers/Utils";
import QuickFilter from "./QuickFilter";
import CommonModal, { CommonModalFooter } from "../../components/shared/modalLayout/CommonModal";
import { getClassByType } from "../../helpers/Utils";
import { glassTypeLabels } from "../../helpers/Utils";
import Loader from "../../components/shared/loader/Loader";
import CustomDropdown from "../../components/shared/dropdown/CustomDropdown";
import { useAuth } from "../auth/AuthContext";
import { P } from "../../utils/permissions";
import { PrintSvg } from "../../svgFiles/PrintSvg";
const OrderFilters = ({
  rowCount,
  selectedIds,
  onClearSelection,
  setShowFilter,
  selectedItems,
  selectedBackerID,
  setSelectedRow,
  selectedShopifyIds,
  onSelectPage,
  onPrint,
  selectedIncludesCancelled = false,
}) => {
  const dispatch = useDispatch();
  const { hasPermission, hasAnyPermission, canSoftDelete } = useAuth();
  // Cancelled selection: only Soft delete; other bulk actions stay off.
  const canRunOtherBulkActions = !selectedIncludesCancelled;
  const canUpdateStatus =
    hasPermission(P.ORDERS_UPDATE_STATUS) && canRunOtherBulkActions;
  const canRedo = hasPermission(P.ORDERS_REDO) && canRunOtherBulkActions;
  const canPrint = hasPermission(P.ORDERS_EXPORT) && canRunOtherBulkActions;
  const canBulkActions = hasAnyPermission(
    P.ORDERS_UPDATE_STATUS,
    P.ORDERS_REDO,
    P.ORDERS_EXPORT,
    P.ORDERS_SEND_TRACKING_MAIL,
    P.PRESCRIPTION_SEND_MAIL
  ) || Boolean(canSoftDelete);
  const [showFilters, setShowFilters] = useState(false);


  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [title, setTitle] = useState("");
  const [pendingAction, setPendingAction] = useState(null);
  const [modalInputValue, setModalInputValue] = useState({});
  const [showPreConfirmModal, setShowPreConfirmModal] = useState(false);
  const [preConfirmMessage, setPreConfirmMessage] = useState('');
  const [showRedoConfirmModal, setShowRedoConfirmModal] = useState(false);
  const [isRedoConfirmLoading, setIsRedoConfirmLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [preConfirmAction, setPreConfirmAction] = useState(null);

  const [updateStatus] = useUpdateOrderStatusMutation();
  const [undoOrder] = useRedoOrderMutation();
  const [softDeleteOrders] = useSoftDeleteOrdersMutation();


  const handleSwitchChange = (e) => {
    const checked = e.target.checked;
    setShowFilters(checked);

    if (checked && selectedIds.length > 0 && selectedItems.length > 0) {
      dispatch(
        setSearch({
          ShopifyItemID: selectedIds,
          selectedShopifyIds: selectedShopifyIds,
          ItemID: selectedItems,
          page: 1,
        })
      );
      dispatch(setHighlightedIds(selectedIds));
      dispatch(setHighlightedShopifyIds(selectedShopifyIds));
      setSelectedRow(true)
    } else {
      dispatch(setSearch({}));
      resetFilters();
      dispatch(clearHighlightedIds());
      dispatch(clearHighlightedShopifyIds());

      setSelectedRow(false)
    }
  };

  const resetFilters = () => {
    onClearSelection?.();
    dispatch(clearHighlightedIds());
    dispatch(clearHighlightedShopifyIds());
  };

  const handleClearAll = () => {
    dispatch(setSearch({}));
    resetFilters();
    dispatch(clearHighlightedIds());
    dispatch(clearHighlightedShopifyIds());
  };

  const handleShowFilter = () => {
    resetFilters();
    setShowFilter(true);

  };

  // 🔹 Open confirm modal when user selects something
  const openConfirmModal = (type, value) => {
    // If changing status to 'Shipped' or 'Lenses Sent', show the pre-confirmation modal first.
    if (type === "status" && (value === "6" || value === "3")) {
      setPreConfirmAction({ type, value });
      const badgeClass = getClassByType(value) || "";
      const preMsg = `<p class="mb-1">This will change the order status of all selected orders to</p>
      <p class="text-start">   <span class="${badgeClass?.class} status-badge">
          ${value}
          <span class="bar">${badgeClass?.title}</span>
        </span></p>`;
      setPreConfirmMessage(preMsg);
      setShowPreConfirmModal(true);
      return;
    }

    setPendingAction({ type, value });
    setModalInputValue({});
    let msg = "";
    let title = "";
    if (type === "status" && value !== "3" && value !== "6") {
      const badgeClass = getClassByType(value) || "";
      msg = `<p class="mb-1">This will change the order status of all selected orders to</p>
        <span class="${badgeClass?.class} status-badge">
          ${value}
          <span class="bar">${badgeClass?.title}</span>
        </span>`;
      title = "Change all selected order status";
    } else if (type === "factory") {
      msg = `Are you sure you want to send items to factory ${value}?`;
      title = "Upload lens batch";
    } else if (type === "redo") {
      msg = `This will redo <strong>${glassTypeLabels[value]}</strong> for all selected orders.`;
      title = `Redo all selected order`;
    } else if (type === "softDelete") {
      msg =
        "This will soft-delete all selected orders (every line item). They will no longer appear in the orders list.";
      title = "Soft delete selected orders";
    }
    setTitle(title);
    setConfirmMessage(msg);
    setShowConfirmModal(true);
  };

  // This runs when the user confirms the *first* modal.
  const handlePreConfirm = () => {
    setShowPreConfirmModal(false);
    if (preConfirmAction?.type === 'status' && preConfirmAction?.value === '6') {
      setPendingAction(preConfirmAction);
      setTitle("Upload tracking number for all selected order");
      setConfirmMessage("tracking");
      setShowConfirmModal(true);
    } else if (preConfirmAction?.type === 'status' && preConfirmAction?.value === '3') {
      setPendingAction(preConfirmAction);
      setTitle("Upload lens batch");
      setConfirmMessage("lensBatch");
      setShowConfirmModal(true);
    }
  };

  const handleFinalRedoConfirm = async (keepData) => {
    if (!pendingAction) return;
    setIsRedoConfirmLoading(true);
    try {
      const result = await undoOrder({
        ItemID: selectedItems,
        redoType: pendingAction.value,
        keepPrescriptionAndMountType: keepData,
      }).unwrap();

      const successes = result.data?.successes || [];
      const errors = result.data?.errors || [];

      if (successes.length > 0) {
        showToast(`${successes.length} order(s) redone successfully`, "success");
      }

      if (errors.length > 0) {
        errors.forEach((e) => {
          showToast(`ID: ${e.ItemID} - ${e.error}`, "error");
        });
      }

      dispatch(setSearch({}));
      resetFilters();
    } catch (err) {
      if (err?.data?.loggedError?.errors?.length) {
        err.data.loggedError.errors.forEach((e) => {
          // Use a fallback if ShopifyItemID is not present in the error response
          const id = e.ShopifyItemID || e.ItemID || 'N/A';
          const errorMessage = e.error || "An unknown error occurred.";
          const message = id !== 'N/A' ? `ID: ${id} - ${errorMessage}` : errorMessage;
          showToast(message, "error");
        });
      } else {
        showToast(err?.data?.message || "Failed to Redo", "error");
      }
    } finally {
      setIsRedoConfirmLoading(false);
      setShowRedoConfirmModal(false);
      setPendingAction(null);
    }
  };

  // 🔹 Confirm modal action
  const handleConfirm = async () => {
    if (!pendingAction) return;

    // If it's a Redo L or F, show the next modal instead of calling the API yet.
    // We return here to keep pendingAction alive for the next step.
    if (pendingAction.type === "redo" && (pendingAction.value === "L" || pendingAction.value === "F")) {
      setShowConfirmModal(false);
      setShowRedoConfirmModal(true);
      return;
    }
    try {
      setIsUpdating(true);
      if (pendingAction.type === "status") {
        if (pendingAction.value === "3") {
          await updateStatus({
            ItemID: selectedItems,
            Status: 3,
            LensList: modalInputValue.lensBatch || "",
          }).unwrap();
          showToast("Lens batch uploaded successfully", "success");
        } else if (pendingAction.value === "6") {
          const trackingNumbersArray = selectedBackerID.map(backerId => modalInputValue[backerId] || "");

          await updateStatus({
            ItemID: selectedItems,
            Status: 6,
            TrackingNumber: trackingNumbersArray,
          }).unwrap();
          showToast("Tracking number uploaded successfully", "success");
        } else {
          await updateStatus({
            ItemID: selectedItems,
            Status: Number(pendingAction.value),
          }).unwrap();
          showToast("Product status updated successfully", "success");
        }
      } else if (pendingAction.type === "redo") {
        // This block now only handles non-L/F redo types
        const result = await undoOrder({
          ItemID: selectedItems,
          redoType: pendingAction.value,
          keepPrescriptionAndMountType: false, // Default for other redo types
        }).unwrap();

        const successes = result.data?.successes || [];
        const errors = result.data?.errors || [];

        if (successes.length > 0) {
          showToast(`${successes.length} order(s) redone successfully`, "success");
        }

        if (errors.length > 0) {
          errors.forEach((e) => {
            showToast(`ID: ${e.ItemID} - ${e.error}`, "error");
          });
        }
      } else if (pendingAction.type === "softDelete") {
        const result = await softDeleteOrders({
          ShopifyIds: selectedShopifyIds,
          ItemID: selectedItems,
        }).unwrap();
        const deleted =
          result?.data?.softDeletedShopifyIds?.length ||
          selectedShopifyIds?.length ||
          0;
        showToast(
          `${deleted} order(s) soft-deleted successfully`,
          "success"
        );
      }

      dispatch(setSearch({}));
      resetFilters();
    } catch (err) {
      console.error("Failed to update:", err);
      if (pendingAction.type === 'redo' && err?.data?.loggedError?.errors?.length) {
        err.data.loggedError.errors.forEach((e) => {
          const id = e.ShopifyItemID || e.ItemID || 'N/A';
          const errorMessage = e.error || "An unknown error occurred.";
          const message = id !== 'N/A' ? `ID: ${id} - ${errorMessage}` : errorMessage;
          showToast(message, "error");
        });
      } else {
        showToast(err?.data?.message || "Something went wrong", "error");
      }
    } finally {
      setIsUpdating(false);
      setShowConfirmModal(false);
      setPendingAction(null);
    }
  };

  return (
    <>
      <ul className="d-flex gap-3 align-items-center w-100 rowFIlter mb-0">
        {isUpdating && <Loader />}
        {/* <li className="d-flex align-items-center gap-2">
          <MinusSvg onClick={handleClearAll} /> {rowCount} Selected
        </li> */}


        {/* {!showFilters && (
          <li>
            <Button
              onClick={handleShowFilter}
              icon={<AddSvg />}
              label="Add filter"
              className="bg-white cancel border-dashed flex-row-reverse"
              size="xs"
            />
          </li>
        )} */}

        {selectedIds.length > 0 && canBulkActions && (
          <>
            {/* 🔹 Selection Options */}
            <li>
              <CustomDropdown
                label={`${rowCount} Selected`}
                options={[
                  { label: "Unselect all", value: "deselectAll" },
                  { label: "Select all on page", value: "selectPage" },
                ]}
                onSelect={(option) => {
                  if (option.value === "deselectAll") {
                    onClearSelection?.();
                  } else if (option.value === "selectPage") {
                    onSelectPage?.(true);
                  }
                }}
              />
            </li>

            {canUpdateStatus && (
            <li>
              <Orderstatus
                label="Change Status"
                statusesOptions={statusesOptions}
                defaultLabel={true}
                onSelect={(status) => {
                  if (status) openConfirmModal("status", status);
                }}
              />
            </li>
            )}

            {canRedo && (
            <li>
              <Glassonly
                label="Redo an Order"
                onSelect={(redoValue) => {
                  if (redoValue) openConfirmModal("redo", redoValue);
                }}
              />
            </li>
            )}

            {canSoftDelete && (
            <li>
              <Button
                label="Soft delete"
                className="bg-white cancel"
                size="xs"
                onClick={() => openConfirmModal("softDelete", true)}
              />
            </li>
            )}

            {canRunOtherBulkActions && (
            <li>
              <QuickFilter
                selectedIds={selectedIds}
                selectedShopifyIds={selectedShopifyIds}
                selectedItems={selectedItems}
                onClearSelection={handleClearAll}
              />
            </li>
            )}

            {canPrint && (
              <li>
                <button
                  type="button"
                  className="selected-print-btn"
                  onClick={onPrint}
                  aria-label="Print selected orders"
                  title="Print selected orders"
                >
                  <PrintSvg />
                </button>
              </li>
            )}
          </>
        )}

        {selectedIds.length > 0 && !canBulkActions && (
          <li>
            <span>{rowCount} Selected</span>
          </li>
        )}

        {/* Switch */}
        {canBulkActions && (
        <li className="ms-auto">
          <Form>
            <Form.Check
              type="switch"
              id="orders-show-selected-switch"
              label="Show all selected"
              onChange={handleSwitchChange}
              disabled={selectedIds.length === 0}
            />
          </Form>
        </li>
        )}
      </ul>

      {/* 🔹 Confirmation Modal */}
      <CommonModal
        show={showConfirmModal}
        setShow={setShowConfirmModal}
        title={title}
        centered
        className="modal-sm"
        onConfirm={handleConfirm}
      >
        <div className="commonBT pt-3 pb-3">
          {confirmMessage === "lensBatch" ? (
            <input
              type="text"
              className="form-control mb-1"
              placeholder="Enter Lens Batch"
              value={modalInputValue.lensBatch || ""}
              onChange={(e) => setModalInputValue({ lensBatch: e.target.value })}
            />
          ) : confirmMessage === "tracking" ? (
            <>
              {selectedBackerID.map((takingFields, index) => {

                return (

                  <InputGroup className="mb-3" key={index}>
                    <InputGroup.Text id="basic-addon1">{takingFields}</InputGroup.Text>
                    <Form.Control
                      placeholder="Enter tracking number"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={modalInputValue[takingFields] || ""}
                      onChange={(e) =>
                        setModalInputValue((prev) => ({ ...prev, [takingFields]: e.target.value }))
                      }
                    />
                  </InputGroup>
                )
              })}
            </>

          ) : (
            <p
              dangerouslySetInnerHTML={{ __html: confirmMessage }}
              className="mb-1"
            ></p>
          )}
        </div>
      </CommonModal>

      {/* Pre-confirmation Modal for Shipped Status */}

      <CommonModal
        show={showPreConfirmModal}
        setShow={setShowPreConfirmModal}
        title="Change all selected order status"
        centered
        className="modal-sm"
        onConfirm={handlePreConfirm}
      >

        <div
          className="pt-3 pb-3 text-center"
          dangerouslySetInnerHTML={{ __html: preConfirmMessage }}
        ></div>
      </CommonModal>

      {/* Second Confirmation Modal for Redo L/F */}
      <CommonModal
        show={showRedoConfirmModal}
        setShow={setShowRedoConfirmModal}
        title="Confirm Redo Action"
        centered
        className="modal-sm"
        footer={
          <CommonModalFooter>
            <Button
              label="Yes, please keep it"
              size="lg"
              onClick={() => handleFinalRedoConfirm(true)}
              isLoading={isRedoConfirmLoading}
            />
            <Button
              label="No, I will reset it"
              onClick={() => handleFinalRedoConfirm(false)}
              className="cancel"
              size="lg"
              disabled={isRedoConfirmLoading}
            />
          </CommonModalFooter>
        }
      >
        <div className="commonBT pt-3 pb-3">
          <p><strong>Would you like to keep the prescription and mount type?</strong></p>
        </div>
      </CommonModal>
    </>
  );
};

export default OrderFilters;
